'use client';
import React from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

export default function AccessibilityPage() {
  return (
    <main style={{ fontFamily: 'Montserrat, sans-serif' }}>
      <Header />

      {/* Hero */}
      <section
        style={{
          backgroundColor: '#003c82',
          padding: '80px 24px 60px',
        }}
      >
        <div style={{ maxWidth: '860px', margin: '0 auto' }}>
          <p style={{ fontSize: '12px', fontWeight: '600', letterSpacing: '0.14em', textTransform: 'uppercase', color: '#6dcff6', marginBottom: '16px' }}>
            Legal
          </p>
          <h1 style={{ fontSize: '42px', fontWeight: '700', color: '#ffffff', margin: 0, lineHeight: 1.15 }}>
            Accessibility Statement
          </h1>
          <p style={{ fontSize: '15px', color: 'rgba(255,255,255,0.65)', marginTop: '16px', marginBottom: 0 }}>
            Last updated: April 2026
          </p>
        </div>
      </section>

      {/* Content */}
      <section style={{ padding: '72px 24px', backgroundColor: '#ffffff' }}>
        <div style={{ maxWidth: '860px', margin: '0 auto' }}>
          <PolicySection title="Our Commitment">
            Brickwell Housing is committed to ensuring digital accessibility for people with disabilities. We continually improve the user experience for everyone and apply relevant accessibility standards to ensure we provide equal access to all users.
          </PolicySection>

          <PolicySection title="Conformance Status">
            We aim to conform to the Web Content Accessibility Guidelines (WCAG) 2.1 Level AA. These guidelines explain how to make web content more accessible to people with disabilities. Conformance with these guidelines helps make the web more user-friendly for all people.
          </PolicySection>

          <PolicySection title="Measures We Take">
            Brickwell Housing takes the following measures to ensure accessibility of our website: we include accessibility as part of our mission and practices, we assign clear accessibility goals and responsibilities, and we employ formal accessibility quality assurance methods. Our team regularly reviews the site to identify and address accessibility barriers.
          </PolicySection>

          <PolicySection title="Technical Specifications">
            Our website relies on the following technologies for conformance with WCAG 2.1: HTML, CSS, JavaScript, and WAI-ARIA. These technologies are relied upon for conformance with the accessibility standards we follow.
          </PolicySection>

          <PolicySection title="Known Limitations">
            Despite our best efforts to ensure accessibility of our website, there may be some limitations. We are actively working to resolve any known issues. If you experience any difficulty accessing content on our site, please contact us so we can assist you.
          </PolicySection>

          <PolicySection title="Feedback and Contact">
            We welcome your feedback on the accessibility of the Brickwell Housing website. If you experience accessibility barriers or have suggestions for improvement, please contact us:<br /><br />
            <strong>Brickwell Housing</strong><br />
            Email: <a href="mailto:info@brickwellhousing.com" style={{ color: '#003c82', textDecoration: 'none' }}>info@brickwellhousing.com</a><br /><br />
            We aim to respond to accessibility feedback within 2 business days.
          </PolicySection>

          <PolicySection title="Formal Complaints">
            If you are not satisfied with our response to your accessibility concern, you may contact the relevant accessibility authority in your jurisdiction. We are committed to working with you to find a resolution.
          </PolicySection>
        </div>
      </section>

      <Footer />
    </main>
  );
}

function PolicySection({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div style={{ marginBottom: '48px' }}>
      <h2 style={{
        fontSize: '20px',
        fontWeight: '700',
        color: '#003c82',
        marginBottom: '14px',
        marginTop: 0,
        paddingBottom: '10px',
        borderBottom: '2px solid #e8f0fb',
      }}>
        {title}
      </h2>
      <p style={{ fontSize: '15px', lineHeight: '1.8', color: '#444444', margin: 0 }}>
        {children}
      </p>
    </div>
  );
}
